(function () {
  var COLLAPSED = 230;
  function setup(card) {
    if (card.getAttribute('data-ready')) return;
    var text = card.querySelector('.sn-mcard-text');
    if (!text || text.scrollHeight <= COLLAPSED + 40) return;
    card.setAttribute('data-ready', '1');
    card.classList.add('is-clamped');
    text.style.maxHeight = COLLAPSED + 'px';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sn-mcard-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="sn-mcard-more">Read more</span><span class="sn-mcard-less">Show less</span><svg class="sn-chev" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    card.appendChild(btn);
    btn.addEventListener('click', function () {
      var open = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      text.style.maxHeight = (open ? text.scrollHeight : COLLAPSED) + 'px';
    });
  }
  function init() {
    var cards = document.querySelectorAll('.sn-mcard');
    for (var i = 0; i < cards.length; i++) setup(cards[i]);
  }
  function refit() {
    var open = document.querySelectorAll('.sn-mcard.is-open .sn-mcard-text');
    for (var i = 0; i < open.length; i++) open[i].style.maxHeight = open[i].scrollHeight + 'px';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  window.addEventListener('resize', refit);
  document.addEventListener('shopify:section:load', init);
})();
